<div class="modal-header">
  <h5 class="modal-title">View on Map</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="row mb-2">
    <div class="col-12">
      <div class="search-container shadow-sm">
        <i class="bi bi-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Search a place..."
          [formControl]="olaSearchControl"
        />
      </div>

      <!-- Dropdown -->
      <ul *ngIf="suggestions.length > 0" class="suggestions-list shadow-sm">
        <li *ngFor="let place of suggestions" (click)="selectPlace(place)">
          <strong>{{ place.structured_formatting.main_text }}</strong>
          <small class="text-muted d-block">
            {{ place.structured_formatting.secondary_text }}
          </small>
        </li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div id="map" style="height: 400px; width: 100%"></div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="universal-cancel-btn"
    (click)="activeModal.dismiss()"
  >
    Cancel
  </button>
  <button type="button" class="universal-submit-btn" (click)="confirmLocation()">
    Confirm Location
  </button>
</div>